module.exports = __webpack_public_path__ + "static/media/sld-logo.db3672b5.svg";